exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_markdown__14Azh{line-height:normal}.style_markdown__14Azh ul{list-style-type:disc;padding-left:2.5rem}.style_markdown__14Azh ol{list-style-type:decimal;padding-left:2.5rem}.style_markdown__14Azh blockquote{border-left:.25rem solid #ccc;padding-left:1rem}", ""]);

// exports
exports.locals = {
	"markdown": "style_markdown__14Azh"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Markdown/style.less
// module id = 1746
// module chunks = 8